import { render, staticRenderFns } from "./ThreeColumns.vue?vue&type=template&id=bc62438e&"
import script from "./ThreeColumns.vue?vue&type=script&lang=js&"
export * from "./ThreeColumns.vue?vue&type=script&lang=js&"
import style0 from "./ThreeColumns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports